// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsGetQuietHoursBody = {};

export type typeNotificationSettingsGetQuietHoursOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    isEnabled: boolean;
    startMinute: number;
    endMinute: number;
    timeZone: string;
  };
};

export type typeNotificationSettingsGetQuietHoursOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsGetQuietHoursOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsGetQuietHoursOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsGetQuietHoursBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsGetQuietHours(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(
      schemaNotificationSettingsGetQuietHoursBody,
    );
  }

  return async function postNotificationSettingsGetQuietHours(
    payload: typeNotificationSettingsGetQuietHoursBody,
  ): Promise<
    | typeNotificationSettingsGetQuietHoursOutput200
    | typeNotificationSettingsGetQuietHoursOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsGetQuietHours" failed before calling the network. #c39d88b878d3`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#c39d88b878d3" },
        },
        data: null,
      } as typeNotificationSettingsGetQuietHoursOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/get-quiet-hours`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsGetQuietHoursOutput200
      | typeNotificationSettingsGetQuietHoursOutput400;
  };
}
